import type React from "react";
import useProfile from "@/hooks/use-profile";
import { Roles } from "@/utilities/types/Users";
import cn from "@/utils/class-names";
import { useTopBarHeight } from "./top-bar-height-context";
import { zIndex } from "@/utilities/constants/zIndex";

interface AgentDashboardTopBarProps {
  className?: string;
}

export default function AgentDashboardTopBar({
  className,
}: AgentDashboardTopBarProps) {
  const { topBarRef, topBarMessage } = useTopBarHeight();
  const { profile } = useProfile();

  const isVisible = profile?.role !== Roles.ADMIN && !!topBarMessage;

  return (
    <div
      ref={topBarRef as React.RefObject<HTMLDivElement>}
      className={cn(
        "fixed w-full bg-black p-2 h-fit flex items-center justify-center",
        `z-[${zIndex.topBar}]`,
        isVisible ? "visible" : "invisible",
        className,
      )}
    >
      <p className="text-base text-white font-semibold w-full text-center">
        {topBarMessage}
      </p>
    </div>
  );
}
